import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { MainLogoWhite } from "../../../../app-constants";
import { Link } from "gatsby";

function Topbarmenu() {
  const [scrolled, setScrolled] = useState(false);
  const [topbarVisible, setTopbarVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      // Trigger topbar menu visibility on scroll
      if (scrollY > 200) {
        // Adjust the scroll value to control when the effect starts
        setTopbarVisible(true);
        setScrolled(true); // For additional classes or styles when scrolled
      } else {
        setTopbarVisible(false);
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <section className={`topbar_menu ${topbarVisible ? "visible" : ""}`}>
      <Container>
        <Row>
          <Col xs={5} md={4} lg={5} xl={5} xxl={5} className="my-auto">
            {MainLogoWhite}
          </Col>
          <Col xs={7} md={8} lg={7} xl={7} xxl={7} className="">
            <div className="topbar_btn">
              <Link
                to="https://meetings.hubspot.com/rshirzadi"
                className="lp-top-btn"
                aria-label="TekRevol Contact"
              >
                Book A Call
              </Link>
              <Link
                href="#getform"
                className="lp-orange_btn"
                aria-label="TekRevol Contact"
              >
                Contact
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Topbarmenu;
